















































import {Component, Prop, Vue, Watch} from "vue-property-decorator";
import {MdbsIdProvider} from "@/api/tsclient";
import RoleDto = MdbsIdProvider.RoleDto;
import {rightsModule, rolesModule} from "@/store";


@Component({})
export default class RoleEditDialog extends Vue {
  @Prop({required: true})
  show!: boolean;

  @Prop({required: true})
  role!: RoleDto;

  identifier?: string | undefined;
  displayName?: string | undefined;
  roleRights: Array<string> = []

  valid: boolean = false;
  loading: boolean = false;

  rules: any = {
    required: (v: string) => !!v || 'Wird benötigt'
  };

  get rights() {
    return rightsModule.rights.sort((r1, r2) => (r1?.displayName ?? "").toString().localeCompare((r2?.displayName ?? "").toString()));
  }

  async mounted() {
    this.loading = true;
    await rightsModule.loadAll();
    this.loading = false;
  }

  @Watch('role', {
    immediate: true
  })
  onUserChanged(role: RoleDto | null) {
    if (!role)
      return;
    this.identifier = role.identifier
    this.displayName = role.displayName
    this.roleRights.updateValues(role.rights?.filter(r => r.id != null).map(r => r.id ?? "") ?? [])
  }

  async save() {
    try {
      this.loading = true;
      if (!this.role.id) {
        await rolesModule.createRole({
          displayName: this.displayName ?? "",
          identifier: this.identifier ?? "",
          rightsIds: this.roleRights
        });
      } else {
        await rolesModule.updateRole({
          id: this.role.id,
          displayName: this.displayName ?? "",
          identifier: this.identifier ?? "",
          rightsIds: this.roleRights
        });
      }
      this.$emit('confirm')
    } catch (e) {
      console.error("editing realPatient failed", e)
    } finally {
      this.loading = false;
    }
  }
}
